/**
 * Defines the what generated the application status log
 */
export enum ApplicationStatusTriggeredBy {
  OwnUser = 0,
  System = 1,
  OtherUser = 2
}
